export enum HostErrorCode {
  NotRegistered = 'not-registered',
  PremiumRequired = 'premium-required',
  RestrictedDevice = 'restricted-device',
  InactiveDevice = 'inactive-device',
  Unknown = 'unknown',
}

export const hostErrorCodes = Object.values(HostErrorCode);
